import React, { useEffect, useRef, useState } from "react";
import {
  StyleSheet,
  TouchableOpacity,
  View,
  TextInput,
  Image as RNImage,
  Text as RNText,
} from "react-native";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "react-native-responsive-screen";
import { Box, Flex, Image, useColorMode, Text, useToast } from "native-base";
import { RFPercentage } from "react-native-responsive-fontsize";
import Input from "../../../../components/Input";
import { useNavigation, useRoute } from "@react-navigation/native";
import Api from "../../../../Api/Api";
import Template from "../../../template/Index.tsx";
import styles from "./styles";
import SkeletonItens from "../../../components/Skeleton/Itens";
import { FlatList } from "react-native";
import { useTheme } from "../../../../ThemeProvider.tsx";
import { CommonActions } from "@react-navigation/native";
import { Entypo, Feather, MaterialCommunityIcons } from "@expo/vector-icons";
import { useToastMessage } from "../../../hooks/useToastMessage";
import TemplateEtapas from "../../../template/Etapas/Index";
import { CORES, sombraCard } from "../../../template/Etapas/styles";
import { corComAlpha, corTextoSobre } from "../../../theme/cores";

export default function Profissional({}) {
  const { getCodEmpresa, isMobile, configEmpresa, primaryColor } = useTheme();

  const toast = useToast();
  const navigation = useNavigation();
  const route = useRoute();

  const [profissionais, setProfissionais] = useState<any[]>([]);
  const [profissionaisOriginal, setProfissionaisOriginal] = useState<any[]>([]);
  const [filtro, setFiltro] = useState<String>("");
  const [buscando, setBuscando] = useState<Boolean>(true);
  const [profissionalSelecionado, setProfissionalSelecionado] =
    useState<any>(null);
  const [fotosComErro, setFotosComErro] = useState<any[]>([]);

  const [getConfigEmpresa, setConfigEmpresa] = useState<any>(
    JSON.parse(configEmpresa),
  );
  const { error } = useToastMessage();

  const refModal = useRef<any>(null);

  const { colorMode, toggleColorMode } = useColorMode();

  useEffect(() => {
    getProfissionais(Number(getCodEmpresa));
  }, []);

  async function getProfissionais(id_empresa: number) {
    let profissionais = await Api.profissionais(id_empresa);

    if (
      route.params.pacoteSelecionado &&
      route.params.pacoteSelecionado.length > 0
    ) {
      const profissionalExtraido = profissionais.data.filter((item) => {
        return item.id === route.params?.pacoteSelecionado[0].funcionario.id;
      });

      // profissionais.data = profissionalExtraido;

      if (route.params.servicos_adicionais) {
        navigation.navigate("Servicos", {
          profissional_selecionado: profissionalExtraido[0],
          ...route.params,
        });
      } else {
        navigation.navigate("Data", {
          profissional_selecionado: profissionalExtraido[0],
          servicos_selecionados: [],
          ...route.params,
        });
      }

      return;
    }

    //

    setProfissionais(profissionais.data);
    setProfissionaisOriginal(profissionais.data);
    setBuscando(false);
  }

  function filtrarProfissionais(text: string) {
    setFiltro(text);
    const profissionais_copy = [...profissionaisOriginal];

    const profissionais_filtrados = profissionais_copy.filter((item) => {
      return item.nome.toUpperCase().includes(text.toUpperCase());
    });

    setProfissionais(profissionais_filtrados);
  }

  function renderFiltro() {
    return (
      <Input
        value={filtro}
        type={"text"}
        icon={"search"}
        onChangeText={filtrarProfissionais}
        colorItem={getConfigEmpresa.coresPWA.corFonteFiltro}
        corBordaFiltro={getConfigEmpresa.coresPWA.corBordaFiltro}
        width={"100%"}
        placeholder="Profissional"
        helperText="Informe o nome do profissional"
      />
    );
  }

  function onPressItemSelecionado(item) {
    if (getConfigEmpresa.utilizaPwaSimples || getConfigEmpresa.versaoPWA == 2) {
      navigation.navigate("Data", {
        profissional_selecionado: item,
        ...route.params,
      });
      return;
    }

    navigation.navigate("Servicos", {
      profissional_selecionado: item,
      ...route.params,
    });
  }

  function linhaProfissional(item: any, index: number) {
    return (
      <Flex key={index} style={styles.containerFlex}>
        {isMobile && (
          <Image
            source={
              item.foto == null
                ? require("../../../img/avatar-pessoa.jpg")
                : {
                    uri: item.foto?.url,
                  }
            }
            alt="Avatar"
            resizeMode="cover"
            height={90}
            width={"23%"}
            borderRadius={6}
          />
        )}

        <Text
          style={{
            fontSize: RFPercentage(2.5),
            marginLeft: 12,
            width: "65%",
            color: getConfigEmpresa.coresPWA.corFontePrimaria,
            fontWeight: "500",
          }}
        >
          {item.nome}
        </Text>

        <Entypo
          name="arrow-with-circle-right"
          size={RFPercentage(5)}
          color={getConfigEmpresa.coresPWA.corFontePrimaria}
          style={{ opacity: 0.5, marginLeft: 5, padding: 2 }}
        />
      </Flex>
    );
  }

  const renderItem = ({ item, index }) => (
    <TouchableOpacity
      key={index}
      style={[
        styles.pressableItem,
        { borderColor: getConfigEmpresa.coresPWA.corBordaItens },
      ]}
      onPress={() => onPressItemSelecionado(item)}
    >
      {buscando ? <SkeletonItens /> : linhaProfissional(item, index)}
    </TouchableOpacity>
  );

  const renderEmptyComponent = () => (
    <Box alignItems="center" justifyContent="center" mt={5}>
      <MaterialCommunityIcons
        name="database-remove"
        size={80}
        color={getConfigEmpresa.coresPWA.corFontePrimaria}
        style={{ marginBottom: 10 }}
      />
      <Text
        style={{
          textAlign: "center",
          fontSize: RFPercentage(2.5),
          color: getConfigEmpresa.coresPWA.corFontePrimaria,
        }}
      >
        Nenhum registro encontrado.
      </Text>
    </Box>
  );

  // ---------------- Layout novo ----------------
  // O modo legado (pwa simples / layout v2 / tema escuro) continua com o template antigo
  const utilizaLayoutLegado =
    getConfigEmpresa.utilizaPwaSimples ||
    getConfigEmpresa.versaoPWA == 2 ||
    getConfigEmpresa.utilizaTemaEscuro;

  const corPrincipal: string = primaryColor || "#006400";

  function voltarInicio() {
    navigation.dispatch(
      CommonActions.reset({
        index: 0,
        routes: [{ name: "TabNavigator", params: { screen: "Inicio" } }],
      }),
    );
  }

  function renderBuscaNova() {
    return (
      <View style={[stylesNovo.busca, sombraCard]}>
        <Feather name="search" size={17} color={CORES.subtitulo} />
        <TextInput
          value={String(filtro)}
          onChangeText={filtrarProfissionais}
          placeholder="Buscar profissional"
          placeholderTextColor={CORES.subtitulo}
          style={stylesNovo.inputBusca as any}
        />
      </View>
    );
  }

  function renderAvatar(item: any) {
    if (item.foto?.url && !fotosComErro.includes(item.id)) {
      return (
        <RNImage
          source={{ uri: item.foto.url }}
          style={stylesNovo.avatar}
          resizeMode="cover"
          onError={() => setFotosComErro((atual) => [...atual, item.id])}
        />
      );
    }

    return (
      <View style={[stylesNovo.avatar, { backgroundColor: corPrincipal }]}>
        <RNText
          style={[stylesNovo.inicialAvatar, { color: corTextoSobre(corPrincipal) }]}
        >
          {(item.nome || "?").trim().charAt(0).toUpperCase()}
        </RNText>
      </View>
    );
  }

  function renderCardProfissional(item: any) {
    const selecionado = profissionalSelecionado?.id === item.id;

    return (
      <TouchableOpacity
        key={item.id}
        activeOpacity={0.85}
        onPress={() => {
          // só existe um profissional por agendamento, então o toque já avança
          setProfissionalSelecionado(item);
          onPressItemSelecionado(item);
        }}
        style={[
          stylesNovo.card,
          sombraCard,
          selecionado && {
            borderColor: corPrincipal,
            backgroundColor: corComAlpha(corPrincipal, 0.06),
          },
        ]}
      >
        {renderAvatar(item)}

        <RNText style={stylesNovo.nome} numberOfLines={2}>
          {item.nome}
        </RNText>

        <View
          style={[
            stylesNovo.radio,
            selecionado && {
              backgroundColor: corPrincipal,
              borderColor: corPrincipal,
            },
          ]}
        >
          {selecionado && (
            <Feather
              name="check"
              size={14}
              color={corTextoSobre(corPrincipal)}
            />
          )}
        </View>
      </TouchableOpacity>
    );
  }

  function renderVazioNovo() {
    return (
      <View style={stylesNovo.vazio}>
        <Feather name="users" size={40} color={CORES.subtitulo} />
        <RNText style={stylesNovo.textoVazio}>
          Nenhum profissional encontrado.
        </RNText>
      </View>
    );
  }

  if (!utilizaLayoutLegado) {
    const primeiroNome = profissionalSelecionado?.nome?.trim().split(" ")[0];

    return (
      <TemplateEtapas
        ref={refModal}
        etapaAtual={1}
        totalEtapas={5}
        titulo={"Com quem você\nquer cortar?"}
        subtitulo="Escolha um profissional para o seu atendimento."
        filtro={renderBuscaNova()}
        onVoltarClick={voltarInicio}
        textoBotao={
          primeiroNome ? `Continuar com ${primeiroNome}` : "Continuar"
        }
        desabilitarBotao={!profissionalSelecionado}
        onBotaoClick={() => {
          if (!profissionalSelecionado) {
            error("Atenção", "Selecione um profissional!");
            return;
          }
          onPressItemSelecionado(profissionalSelecionado);
        }}
      >
        {buscando ? (
          <SkeletonItens />
        ) : profissionais.length === 0 ? (
          renderVazioNovo()
        ) : (
          profissionais.map((item) => renderCardProfissional(item))
        )}
      </TemplateEtapas>
    );
  }

  // ---------------- Layout legado ----------------
  return (
    <Template
      titulo={"Selecione o Profissional"}
      messageAlerta="Por gentileza, selecione o profissional para realizar o serviço"
      onBotaoProximoClick={() => {
        error("Atenção", "Selecione pelo menos um profissional!");
      }}
      filtro={renderFiltro()}
      onBotaoVoltarClick={() => {
        navigation.dispatch(
          CommonActions.reset({
            index: 0,
            routes: [{ name: "TabNavigator", params: { screen: "Inicio" } }],
          }),
        );
      }}
      ref={refModal}
    >
      <Box style={styles.mainContainer}>
        <FlatList
          data={profissionais}
          renderItem={renderItem}
          ListEmptyComponent={
            buscando ? <SkeletonItens /> : renderEmptyComponent
          }
          keyExtractor={(item, index) => index.toString()}
          contentContainerStyle={{
            width: wp("98%"),
          }}
        />
      </Box>
    </Template>
  );
}

const stylesNovo = StyleSheet.create({
  busca: {
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
    height: 48,
    paddingHorizontal: 14,
    borderRadius: 14,
    backgroundColor: CORES.card,
    borderWidth: 1,
    borderColor: CORES.borda,
  },
  inputBusca: {
    flex: 1,
    height: "100%",
    fontSize: 15,
    color: CORES.titulo,
    outlineStyle: "none",
  },
  card: {
    flexDirection: "row",
    alignItems: "center",
    gap: 14,
    padding: 14,
    marginBottom: 12,
    borderRadius: 18,
    backgroundColor: CORES.card,
    borderWidth: 1.5,
    borderColor: "transparent",
  },
  avatar: {
    width: 52,
    height: 52,
    borderRadius: 14,
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  inicialAvatar: {
    fontSize: 22,
    fontWeight: "800",
  },
  nome: {
    flex: 1,
    fontSize: 16,
    fontWeight: "700",
    color: CORES.titulo,
  },
  radio: {
    width: 24,
    height: 24,
    borderRadius: 12,
    borderWidth: 1.5,
    borderColor: "#cfcfcf",
    alignItems: "center",
    justifyContent: "center",
  },
  vazio: {
    alignItems: "center",
    paddingVertical: 40,
    gap: 12,
  },
  textoVazio: {
    fontSize: 15,
    color: CORES.subtitulo,
  },
});
